
import { ContextRedirectConfig, ContextRedirects } from '@npm.chapps.com/chapps.common.angular.library';

export class AppContextRedirectConfig {

    static REDIRECT_CONFIGS: ContextRedirects = [
            {
                objectType: 'BUILDING',
                redirect: (context) =>  `/jobs/interventions?building=${context.objectId}`
            }
    ];

    static CONFIG: ContextRedirectConfig = new ContextRedirectConfig(AppContextRedirectConfig.REDIRECT_CONFIGS, () => '/');
}
